/**
 * Список обучающих роликов. Тексты лежат в переводах (`tutorials.items.<id>`),
 * здесь — только порядок и данные с YouTube.
 *
 * Как добавить опубликованный ролик: залить видео на канал и вписать сюда `youtubeId`
 * из ссылки (`youtube.com/watch?v=ЭТО_ОН`) и `duration` как на YouTube. Пока `youtubeId`
 * пустой, карточка показывается неактивной с плашкой «Скоро» — так страница честно
 * показывает план курса и не даёт битых ссылок.
 *
 * Сценарии роликов и метаданные для YouTube: docs/tutorials/.
 */
export interface Tutorial {
  /** Ключ в переводах и в разметке, он же порядковый смысл ролика */
  id: string;
  /** Идентификатор видео на YouTube, null — ролик ещё не опубликован */
  youtubeId: string | null;
  /** Длительность как на YouTube, показывается на карточке */
  duration: string | null;
}

export const TUTORIALS: Tutorial[] = [
  { id: 'registration', youtubeId: 'pxWBNR6QHKM', duration: '2:42' },
  { id: 'freightSearch', youtubeId: null, duration: null },
  { id: 'addFreight', youtubeId: null, duration: null },
  { id: 'chatDeal', youtubeId: null, duration: null },
  { id: 'employees', youtubeId: null, duration: null },
];

/** Ролик по id, если он уже опубликован. Нужен подсказкам в интерфейсе: пока ролика нет, подсказку не показываем */
export const publishedTutorial = (id: string): Tutorial | undefined =>
  TUTORIALS.find((tutorial) => tutorial.id === id && tutorial.youtubeId);

/** Превью берём прямо у YouTube: hqdefault есть у любого видео, в отличие от maxresdefault */
export const youtubePreview = (youtubeId: string) => `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;

export const youtubeWatchUrl = (youtubeId: string) => `https://www.youtube.com/watch?v=${youtubeId}`;

/** Плеер без cookies и без подборки чужих видео в конце (rel=0) */
export const youtubeEmbedUrl = (youtubeId: string) =>
  `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&hl=ru&cc_lang_pref=ru`;
